import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FooterNavigation, Header, PaginationHelper, TitleBar, Dialog } from "webapp/components";
import { DHMemberInformationForm } from "webapp/components/Partner/D&H/DHMemberInformationForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function DHMemberInformation(props) {
  const { t } = useTranslation();
  const [showFooter, setShowFooter] = useState(false);
  const [memberInfo, setMemberInfo] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [isSelectedContact, setIsSelectedContact] = useState(false);

  const [showSelectUserModal, setShowSelectUserModal] = useState(false);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("description.PolicyInformationVerifyHeader")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onUserNext = () => {
    const isContactSelected =
      selectedContact !== null && (typeof selectedContact === "object" || typeof selectedContact === "undefined");
    devLog("onUserNext", memberInfo, selectedContact, isContactSelected);
    if (isContactSelected) {
      props.context.setState(
        {
          accountRef: selectedContact.accountRef,
          contactRef: selectedContact?.contactRef,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.onUserNext === "function") {
            props.onUserNext();
          }
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */
      setShowSelectUserModal(true);
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };
  const onContractLookupComplete = (success) => {
    setShowFooter(!!success);
  };

  // const onUserSelectMember = (contactInfo, selectedContact) => {
  //   devLog("onUserSelectMember", contactInfo, selectedContact);
  //   setMemberInfo(contactInfo);
  //   setSelectedContact(selectedContact);
  //   const isSelected =
  //     selectedContact !== null &&
  //     (typeof selectedContact === "object" ||
  //       typeof selectedContact === "undefined");
  //   setIsSelectedContact(isSelected);
  //   devLog("showFooter && isSelectedContact: " + selectedContact);
  // };

  const onUserSelectMember = (selectedContact) => {
    devLog("onUserSelectMember", selectedContact);
    // setMemberInfo(contactInfo);
    setSelectedContact(selectedContact);
    const isSelected =
      selectedContact !== null && (typeof selectedContact === "object" || typeof selectedContact === "undefined");
    setIsSelectedContact(isSelected);
    devLog("showFooter && isSelectedContact: " + selectedContact);
  };

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("BWC.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <DHMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
          onMemberInfo={onUserSelectMember}
        />
      </div>
      {showFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}
      {showSelectUserModal && (
        <Dialog
          title={"DriverMissing"}
          message={"ErrorSelectContacts"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowSelectUserModal(false);
          }}
        />
      )}
    </>
  );
}

export default DHMemberInformation;
